module.exports = "/images/mail-settings-instruction.png?5c433ef35fcb5f4be5d7092019e7db92";


//////////////////
// WEBPACK FOOTER
// ./public/img/mail-settings-instruction.png
// module id = Wmp8
// module chunks = 5